module.exports = __webpack_public_path__ + "static/cr-ee79f88336ed548ed8931611ce5dc907.svg";